var map = {
	"./404-error.png": 77104,
	"./Email.png": 52225,
	"./Notification.png": 25093,
	"./SMS.png": 34146,
	"./a.png": 11507,
	"./a1.png": 981,
	"./a2.png": 22228,
	"./approval.png": 73963,
	"./attach-file.png": 82423,
	"./attendance.png": 13769,
	"./b.png": 23034,
	"./booking.png": 48090,
	"./briefcase.png": 45796,
	"./c.png": 19900,
	"./cart.png": 46393,
	"./chatbot.png": 42563,
	"./connectionError.png": 91239,
	"./ex_hours.png": 32458,
	"./exit.png": 78763,
	"./food.png": 41910,
	"./gallery.png": 15816,
	"./healthcare.png": 53686,
	"./maintenance.png": 19347,
	"./personal.png": 49325,
	"./reservation.png": 40083,
	"./scanner.png": 66004,
	"./settings.png": 34476,
	"./store.png": 16310,
	"./telephonedirectory.png": 25123,
	"./time_endoresement.png": 99239,
	"./to-do-list.png": 11715,
	"./tools.png": 7832,
	"./user-check.png": 5024,
	"./user.png": 40856,
	"./welfare.png": 16581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;